var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryRange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6002",
    "data-name": "Group 6002",
    transform: "translate(-1003 -675)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_314",
    "data-name": "Ellipse 314",
    cx: 29,
    cy: 29,
    r: 29,
    transform: "translate(1003 675)",
    fill: "#eef4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g831",
    transform: "translate(1018 1372.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g833",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5995",
    "data-name": "Group 5995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g841",
    transform: "translate(5.125 1.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path843",
    d: "M-40.861-327.554l5.128,6.837a2.133,2.133,0,0,0,1.709.855,2.133,2.133,0,0,0,1.709-.855l5.128-6.837a8.5,8.5,0,0,0,1.7-5.121,8.542,8.542,0,0,0-8.542-8.542,8.542,8.542,0,0,0-8.542,8.542A8.5,8.5,0,0,0-40.861-327.554Z",
    transform: "translate(42.565 341.216)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g845",
    transform: "translate(11.532 7.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path847",
    d: "M-102.4-51.2a2.136,2.136,0,0,1-2.136,2.136,2.136,2.136,0,0,1-2.136-2.136,2.136,2.136,0,0,1,2.136-2.136A2.136,2.136,0,0,1-102.4-51.2Z",
    transform: "translate(106.666 53.333)",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "g849",
    transform: "translate(9.396 26.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path851",
    d: "M0,0H8.542",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryRange);
export default __webpack_public_path__ + "static/media/DeliveryRange.0072e1d5da7e8737ad57adc167bb5562.svg";
export { ForwardRef as ReactComponent };